import { CardDetails } from '../../../../../../common/components/CardDetails/CardDetails';
import style from "./style.module.scss"
import dayjs from 'dayjs';

type HatchCoverDetailsTypes = {
    initialValue?: any
}
function HatchCoverDetails({initialValue}: HatchCoverDetailsTypes) {

    const renderValue = (value : any /* string | number | boolean */) => {
        return value ? value : "-";
      };

    const chalandValue = () => {
        return (initialValue?.isBargeUsed ? "oui" : "non");
    }

  return (
    <div>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Action : </span>
                <span className={style.details__value}>{renderValue(initialValue?.hatchCoverAction?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Panneau : </span>
                <span className={style.details__value}>{renderValue(initialValue?.pannelPosition?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>N° de cale : </span>
                <span className={style.details__value}>{renderValue(initialValue?.caleNumber)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>N° bay : </span>
                <span className={style.details__value}>{renderValue(initialValue?.bayNumber)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type de panneau : </span>
                <span className={style.details__value}>{renderValue(initialValue?.pannelType?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage (T) : </span>
                <span className={style.details__value}>{renderValue(initialValue?.tonnage)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Date : </span>
                <span className={style.details__value}>{renderValue(dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YY"))}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Heure de début : </span>
                <span className={style.details__value}>{renderValue(dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm").format("HH:mm"))}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Heure de fin : </span>
                <span className={style.details__value}>{renderValue(dayjs(initialValue?.endAt, "DD/MM/YYYY HH:mm").format("HH:mm"))}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Chaland : </span>
                <span className={style.details__value}>{renderValue(chalandValue())}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Référence chaland : </span>
                <span className={style.details__value}>{renderValue(initialValue?.bargeMaterial?.reference)}</span>

              </div>
            </CardDetails>
    </div>
  )
}

export default HatchCoverDetails